import script from "./SelectField.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectField.vue?vue&type=script&setup=true&lang=js"

import "./SelectField.vue?vue&type=style&index=0&id=2324d496&scoped=true&lang=scss"

import exportComponent from "/Users/xujunfeng/Desktop/project/school/digital_factory_server/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2324d496"]])

export default __exports__